// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3mObx","my":"Header_my__2OcEi","header--dark":"Header_header--dark__32ITo"};